<template>
<div>
	<window-for-View ref="Window" class="stationId" :bg="true">
		<div slot="head" class="head bg">
     <span class="title mt05x fs12x curP">{{getLanguageStr('phrase716','本商家对当前电站的功能权限')}}</span>
		</div>
		<div fillHeight="lastHeight" scroll class="pl1x pr1x pt1x">
			<div class="mb2x lh15">
        <span v-if="entityRel.sourceEntityType==1" :title="(entityRel.organization.name||'--')+'('+$t('word1650',['商家'])+')'">
          {{$t('plant_detail23',[entityRel.organization.name,'本电站由{0}（商家）授权。'])}}
        </span>
        <span v-else :title="(entityRel.userInfo.name||'--')+'('+$t('word1546',['用户'])+')'">
            {{$t('plant_detail24',[entityRel.userInfo.name,'本电站由{0}（用户）授权。'])}}
        </span>{{getLanguageStr('phrase717','以下是本商家对当前电站的功能权限列表，具体到每个成员的功能权限由该成员的角色决定。')}}
      </div>
			<ul>
				<li v-for="(item,index) in list" class="tableSys mb1x fs12x" :key="index">
					<div class="w1x">{{index+1}}.</div>
					<div class="pl05x pr05x">
            <div class="flex"><span>{{item.text}}</span>&nbsp;&nbsp;<span class="dashBorder flex1 bdSub-top"></span>
            </div>
          </div>
					<div class="w3x taC">
            <Icon name="yes" class="w1x h1x fField" v-if="item.isOn==2"/>
            <Icon name="no" class="w1x h1x fField" v-if="item.isOn==0"/>
          </div>
				</li>
			</ul>
		</div>
	</window-for-View>
</div>
</template>
<script>
import * as lib from '@/util/lib'
import WindowForView from '@/components/common/ui/WindowForView'
import {getLanguageStr} from '@/util/language'

export default {
  name: 'PromiseList',
  components: {WindowForView},
  props:{
    roleCode:{
      type:Array,
      default:(()=>{[]})
    }
  },
  data () {
    return {
      list: [
        {text: getLanguageStr('cmd183', '编辑电站'), type: true, code: 'A1',isOn:0 },
        {text: getLanguageStr('cmd184', '设置电站'), type: true, code: 'A2',isOn:0 },
        {text: getLanguageStr('cmd188', '查看子系统/设备'), type: true, code: 'A3',isOn:0 },
        {text: getLanguageStr('cmd189', '添加新子系统/设备'), type: true, code: 'A4',isOn:0 },
        {text: getLanguageStr('cmd190', '编辑子系统/设备'), type: true, code: 'A5' ,isOn:0},
        {text: getLanguageStr('cmd191', '删除子系统/设备'), type: true, code: 'A6',isOn:0 },
        {text: getLanguageStr('cmd192', '查看电站报警'), type: true, code: 'A7',isOn:0 },
        {text: getLanguageStr('cmd193', '查看关于电站'), type: true, code: 'A8',isOn:0 },
        {text: getLanguageStr('manage324', '查看系统布局'), type: true, code: 'A9',isOn:0 }
      ],
      entityRel:{
        userInfo:{}
      }
    }
  },
  methods: {
    getLanguageStr,
    show (data) {
      if(data){
        this.entityRel=data
      }
      this.computedCode(this.roleCode)
      this.$refs.Window.show()
      this.$refs.Window.loadStatusAction(false)
    },
    computedCode(arr){
      let codeList=arr.filter(el=>el.code.length!=2)
      codeList.forEach(el=>{
        this.list.forEach(attr=>{
          if(attr.code==el.code.split('/')[1]){
            attr.isOn=el.isOn
          }
        })
      })
    }
  },
  computed: {
  },
  mounted () {
    lib.setScroll($(this.$el).find('[scroll]'))
  }
}
</script>
<style lang="scss" scoped>

.transform{
	transform: rotateY(180deg);
	height: 0.6em

}
.config-list{
	li{
		padding-left:1.5em;
		height:3em;
		font-size: 1.2em;
		line-height: 3em;
		border-bottom:1px solid rgba(0, 0, 0, 0.1);
	}
}
.stationId :deep(.body){
	width: 40%;
}
.flex{
  display: flex;
  align-items:center;
  span{
    white-space: nowrap;
  }
  .flex1{
    flex: 1
  }
}
.dashBorder{
  width: 100%;
  height: 1px;
  border-top-style: dashed;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/PromiseList.vue